export default __webpack_public_path__ + "static/media/vue.70d78e8a.svg";